import React from "react";
import { Alert, Button } from "@mui/material";
import { useAuth } from "@auth/AuthContext";

/**
 * Banner shown when the user's in-memory permission set diverges from the
 * server-side state (detected by an /me re-fetch on focus / visibility /
 * 10-min interval). Lets the user opt into a hard refresh rather than
 * silently mutating the UI mid-form. (Ref: LWI-661 / Permissions Refactor.)
 */
export default function StalePermissionsBanner() {
  const { permissionsStale, refreshAuth } = useAuth();

  if (!permissionsStale) return null;

  return (
    <Alert
      severity="warning"
      action={
        <Button
          color="inherit"
          size="small"
          onClick={() => {
            // window.location.reload() is the simplest way to reset every
            // page's local state to match the new permission set. The
            // permissions are already up to date in AuthContext at this
            // point — refreshAuth() is offered for completeness but the
            // page-level reload is what users actually want.
            refreshAuth?.();
            window.location.reload();
          }}
        >
          Refresh now
        </Button>
      }
      sx={{ borderRadius: 0 }}
    >
      Your access has changed. Refresh to apply the new permissions.
    </Alert>
  );
}
